/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:03]
Permissions to update outside the main branch: [false]
*/

import { Filter, Input, Setting, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { Col, Row } from 'reactstrap';

export default function SettingsFilter() {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<Filter<Setting>>();
    return (
        <>
            <Row>
                <Col>
                    <Input
                        id="ds-code-id"
                        value={draftFilter.code || ''}
                        name="code"
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({ ...prevState, code: e.target.value }))
                        }
                        label={t('BackOfficeCode')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-value-id"
                        value={draftFilter.value || ''}
                        name="value"
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({ ...prevState, value: e.target.value }))
                        }
                        label={t('BackOfficeValue')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-dsc-id"
                        value={draftFilter.dsc || ''}
                        name="dsc"
                        onChange={(e) =>
                            setDraftFilter((prevState) => ({ ...prevState, dsc: e.target.value }))
                        }
                        label={t('BackOfficeDescription')}
                    />
                </Col>
            </Row>
        </>
    );
}
